/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import React from "react";
import { isArrayNotEmpty } from "utils/empty-exists";
import { IconLinkItem } from "./icon-link-item";

const ServiceListTabContentDisplay = (props) => {
    
    const tab = props?.tab ?? {};
    const iconLinks = tab?.icon_links ?? [];
    const hasContent = isArrayNotEmpty(iconLinks);
    
    return (
        <>
            {!hasContent &&
                <h4 style={{ textAlign: "center", paddingTop: "2em", color: "#cecece" }}>
                    Click Edit to start adding tab content
                </h4>
            }
            {hasContent &&
                <div className='icon-link-tabs-content'>
                    {iconLinks.map((iconLink) => {
                        const guid = iconLink?.guid;
                        return (
                            <IconLinkItem key={guid} iconLink={iconLink} />
                        );
                    })}
                </div>
            }
        </>
    );
};

ServiceListTabContentDisplay.displayName = "ServiceListTabContentDisplay";
export { ServiceListTabContentDisplay };
